import { QUERY_PARAM_AFTER_LOGIN } from 'constants/queryAndStorageKeys';

import { isObject, trimCharsEnd } from 'lodash/fp';

import { History, UseLocation } from '@skippay/core/hooks/useLocation';
import { createHref } from '@skippay/core/utils/routeUtils';
import { isAbsoluteURL } from '@skippay/core/utils/urlUtils';

export { createHref };

const trimTrailingSlash = trimCharsEnd(`/`);

export function createAbsoluteHref(
	location: Partial<UseLocation> | string,
	baseUrl: string
): string {
	const stringLocation = isObject(location) ? createHref(location) : location;
	return isAbsoluteURL(stringLocation)
		? stringLocation
		: baseUrl + trimTrailingSlash(stringLocation);
}

export function hasHistoryStack(history: History): boolean {
	return !!history.length && !history.location.state?.[QUERY_PARAM_AFTER_LOGIN];
}
